var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.expirationTimeText)?_c('span',[_vm._v(_vm._s(_vm.expirationTimeText))]):_vm._e(),_vm._v(" "),(_vm.isExpired)?_c('span',{staticClass:"cs-emailVideo-expired-label"},[_vm._v("（已过期）")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6803211a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/paginationCells/emailVideoExpirationCell.vue
// module id = 2R6F
// module chunks = 0